<template>
  <div>
    <div
      class="card card_white flex-fill"
      :class="selected ? 'selected' : ''"
      style="margin-bottom: 8px; cursor: pointer"
      v-bind:style="height != null ? 'height: ' + height + 'px;' : ''"
    >
      <div class="sub_title_2">
        <span>Empty Data</span>
      </div>
      <div class="data_text">0</div>
      <div class="d-flex mt-2">
        <div class="d-inline-flex align-items-center me-2 badge_red">
          <IconSvg color="red" type="arrow_down" />
          <div class="data_detil" style="color: red">0</div>
        </div>
        <div class="d-inline-flex align-items-center me-2 badge_red">
          <IconSvg color="red" type="chart_down" />
          <div class="data_detil" style="color: red">0</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import { formattedNumber } from "@/utils/helper";

export default {
  components: {
    IconSvg,
  },
  props: {
    param: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
    selected: {
      type: Boolean,
      required: false,
    },
  },
  mounted() {},
  methods: {
    formattedNumber,
  },
};
</script>

<style scoped>
.selected {
  background-color: #ecf9ff;
  border: 1px solid #00a3e9;
}
</style>
